import { render, staticRenderFns } from "./NotificationsTab.vue?vue&type=template&id=3481632a&scoped=true"
import script from "./NotificationsTab.vue?vue&type=script&lang=js"
export * from "./NotificationsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481632a",
  null
  
)

export default component.exports